export enum EmailActionTypeEnum {
  ACCEPT= 'ACCEPT',
  DECLINE = 'DECLINE',
}